import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { Box, CircularProgress, CssBaseline } from "@mui/material";
import TopNavigation from "./components/TopNavigation";
// import ContactListView from "./views/ContactListView";
import TagListView from "./views/TagListView";
import BroadcastView from "./views/BroadcastView";
import ContactView from "./views/ContactView";
import AutomationView from "./views/AutomationView";
import { FlowCanvas } from "./views/FlowCanvas";
import TeamChatView from "./views/TeamChatView";
import "./App.css";
import { SignInPage } from "./setup/signin";
import MyAccountService from "./services/MyAccountService";
import appConfig from "./shared/js/app-config";
import CheckoutView from "./views/CheckoutView";
import { SignUpPage } from "./setup/signup";
// import { CreateService } from "./setup/create-service";
// import ServicesService from "./services/ServicesService";
import { Terms } from "./setup/terms";
import { Privacy } from "./setup/privacy";
import PlansView from "./views/PlansView";
import GroupView from "./views/GroupView";

// Wrapper to inject routing props into TopNavigation
function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const getActiveTab = () => {
    if (location.pathname.startsWith("/tags")) return "tags";
    if (location.pathname.startsWith("/broadcast")) return "broadcast";
    if (location.pathname.startsWith("/teamchat")) return "teamchat";
    if (location.pathname.startsWith("/automation")) return "automation";
    if (location.pathname.startsWith("/flow")) return "flow";
    if (location.pathname.startsWith("/chat")) return "chat";
    if (location.pathname.startsWith("/plan")) return "plan";
    if (location.pathname.startsWith("/group")) return "group";
    return "contacts";
  };

  const handleTabChange = (tabId) => {
    navigate(`/${tabId}`);
  };

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <CssBaseline />
      {!location.pathname.startsWith('/checkout') && (
        <TopNavigation
        onMenuClick={() => {}}
        title="WappGrow Dashboard"
        activeTab={getActiveTab()}
        onTabChange={handleTabChange}
      />
      )}
      <Box
        sx={{
          mt: "64px",
          width: "100%",
          height: "calc(100vh - 64px)",
          overflow: "hidden",
        }}
      >
        <Routes>
          <Route path="/contacts" element={<ContactView />} />
          <Route path="/tags" element={<TagListView />} />
          <Route path="/broadcast" element={<BroadcastView />} />
          <Route path="/teamchat" element={<TeamChatView />} />
          <Route path="/checkout" element={<CheckoutView />} />
          <Route path="/plan" element={<PlansView />} />
          <Route path="/group" element={<GroupView />} />
          <Route
            path="/automation"
            element={
              <AutomationView
                onNavigateToFlow={(id) => navigate(`/flow/${id}`)}
              />
            }
          />
          <Route path="/flow/:automationId" element={<FlowCanvasWrapper />} />
          <Route path="/flow" element={<FlowCanvasWrapper />} />
          <Route path="*" element={<Navigate to="/teamchat" replace />} />
        </Routes>
      </Box>
    </Box>
  );
}

function FlowCanvasWrapper() {
  const id = useParams();
  return <FlowCanvas automationId={id.automationId} />;
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [orgId, setOrgId] = useState(null);
  const [store, setStore] = useState([]);
  useEffect(() => {
    async function initializeApp() {
      try {
        await appConfig.fetch();
      } catch (err) {
        console.log("App config fetch failed:", err);
        // Continue with login check even if config fails
      }

      try {
        const account = await MyAccountService.fetch();
        // const organizationId = account.getOrganizationId();
        // setOrgId(organizationId);
        // if (organizationId) {
        // const service = await ServicesService.getOrganizationServices({ organizationId });
        // setStore(service);
        // }
              setIsLoggedIn(!!account?.getId());
      } catch (err) {
        console.log("Account fetch failed:", err);
        setIsLoggedIn(false);
      }
    }
    initializeApp();
  }, []);
  if (isLoggedIn === null) {
    // Show nice centered loader
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={60} thickness={4} />
      </Box>
    );
  }
  return (
    <Router>
      <Routes>
        <Route path="/checkout" element={<CheckoutView />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        {isLoggedIn ? (
          <>
            {/* No org or no services => redirect to create service */}
            {/* {(!orgId || store.length === 0) ? (
              <>
                <Route path="/create-service" element={<CreateService />} />
                <Route path="*" element={<Navigate to="/create-service" replace />} />
              </>
            ) : ( */}
              <>
                <Route path="/*" element={<Layout />} />
              </>
            {/* )} */}
          </>
        ) : (
          <>
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            {/* <Route path="/create-service" element={<CreateService />} /> */}
            <Route path="*" element={<Navigate to="/signin" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
